import { render } from "./ItemCard.vue?vue&type=template&id=c85d0bf6&scoped=true"
import script from "./ItemCard.vue?vue&type=script&lang=js"
export * from "./ItemCard.vue?vue&type=script&lang=js"

import "./ItemCard.vue?vue&type=style&index=0&id=c85d0bf6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c85d0bf6"

export default script